import { ReactNode } from "react";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Subtitle.module.css";

type SubtitleProps = {
  children: ReactNode;
  light?: boolean | undefined;
};

function Subtitle({ children, light = false }: SubtitleProps) {
  const className = light ? styles["light"]! : "";

  return <FixaText className={className}>{children}</FixaText>;
}

export default Subtitle;
